import { render } from "./NodeVideo.vue?vue&type=template&id=2868e8ad"
import script from "./NodeVideo.vue?vue&type=script&lang=js"
export * from "./NodeVideo.vue?vue&type=script&lang=js"
script.render = render

export default script